import { ConfigTypeOverride } from '@cp/shared/config';
import { ConfigManager } from 'src/shared/config/manager';
import { contacts } from './contacts';
import { legalConfig } from './legal';
import { SOCIAL_MEDIA } from './socialMedia';
import { SUPPORT } from './support';

export const createConfig = (runtimeConfig: Record<string, unknown> = {}) => {
  return new ConfigManager<ConfigTypeOverride>({
    ...contacts,
    ...legalConfig,
    ...SOCIAL_MEDIA,
    ...SUPPORT,
    ...runtimeConfig,
  } as ConfigTypeOverride);
};
